export const defaultLocales = {
    en: 'en-US',
    de: 'de-DE'
};

export const languagesHelper = Object.keys(defaultLocales) as (keyof typeof defaultLocales)[];

export const getShortLanguageCode = (lang: string | undefined | null) => lang && typeof lang === 'string' && lang.split('-', 1)[0];

export const getValidLocale = (code: string | undefined | null) => {
    // Check if string matches the minimum requirements for support
    if (!code || typeof code !== 'string' || code.length < 2) {
        return defaultLocales.de;
    }

    // Check if string matches 'xx' code (i.e 'en' or 'de' from navigator language)
    if (languagesHelper.includes(code as keyof typeof defaultLocales) && code.length === 2) {
        return defaultLocales[code as keyof typeof defaultLocales];
    }

    // Check if the code short version is listed
    const shortCode = getShortLanguageCode(code) as keyof typeof defaultLocales;
    if (!shortCode || defaultLocales[shortCode] === undefined) {
        return defaultLocales.de;
    }

    return defaultLocales[shortCode];
};
